
import Heading from './../../heading';
import { PropTypes } from 'prop-types';
import useFetch from '../../../utils/useFetch';
import { DecodeHtml } from '../../../utils/decodeHtml';
const ModelView = ({ url }) => {

    const data = useFetch(url)
    const admissionData = data?.properties
    const title = admissionData?.title
    const content = DecodeHtml({ html: admissionData?.richTextContent?.markup })

    return (
        <div className="flex flex-col gap-5 w-full text-  p-4 max-h-[80vh] max-w-[80vw]  overflow-y-auto scroll-bar">
            <Heading name="How to apply" color="text-blue-600" />
            <h1 className=" text-zinc-950 text-xl sm:text-3xl font-bold">{title}</h1>
            <div className='grid gap-14 text-zinc-950 whitespace-pre-line'>
                {
                    content
                }

            </div>
        </div >
    )
}
ModelView.propTypes = {
    url: PropTypes.any
}
export default ModelView